import React, { ReactElement } from 'react';
import { useParams } from 'react-router';
import LegislativnyMaterialDetailRow from './component/LegislativnyMaterialDetailRow';
import mapDate from '../../../../../function/mapDate';
import LegislativnyMaterialDetail
  from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import SuvisiaciProcesList from './component/SuvisiaciProcesList';
import NovelizovanyPredpis from './component/NovelizovanyPredpis';
import AktEu from './component/AktEu';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
}

const LegislativnyMaterialBasicData = ({ materialDetail }: Props): ReactElement => {
  const {
    type,
  } = useParams<{ type: string }>();

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  return (
    <>
      <LegislativnyMaterialDetailRow
        header="Aktuálne štádium materiálu"
        data={materialDetail?.stadium?.nazov}
      />
      <LegislativnyMaterialDetailRow
        header="Dôvod ukončenia procesu"
        data={materialDetail.dovodUkoncenia}
      />
      <LegislativnyMaterialDetailRow
        header="Typ materiálu"
        data={materialDetail?.typ?.nazov}
      />
      <LegislativnyMaterialDetailRow
        header="Právna oblasť"
        data={materialDetail?.oblastList}
        itemAttributeToShow="nazov"
      />
      <LegislativnyMaterialDetailRow
        header="Číslo procesu"
        data={materialDetail.cisloLegislativnehoMaterialu}
      />
      <AktEu data={materialDetail?.aktEu} />
      <LegislativnyMaterialDetailRow
        header="Gestor"
        data={materialDetail?.gestor?.uplnyNazov}
      />
      <LegislativnyMaterialDetailRow
        header="Spolugestori"
        data={materialDetail?.spolugestori}
        itemAttributeToShow="uplnyNazov"
      />
      <LegislativnyMaterialDetailRow
        header="Zdôvodnenie neschválenia gestora"
        data={materialDetail?.dovodOdmietnutiaGestora}
      />
      <LegislativnyMaterialDetailRow
        header="Námietka ku gestorstvu"
        data={materialDetail?.namietkaKuGestorstvu}
      />
      <LegislativnyMaterialDetailRow
        header="Kategória aktu"
        data={materialDetail?.kategoriaAktu?.nazov}
      />
      <LegislativnyMaterialDetailRow
        header="Stupeň dôležitosti"
        data={materialDetail?.stupenDolezitostiAktu?.nazov}
      />
      <LegislativnyMaterialDetailRow
        header="Rezortné číslo"
        data={materialDetail?.rezortneCislo}
      />
      <LegislativnyMaterialDetailRow
        header="Podnet"
        data={materialDetail?.podnet}
      />
      <LegislativnyMaterialDetailRow
        header="Zodpovedná inštitúcia"
        data={materialDetail?.zodpovednaInstitucia?.uplnyNazov}
      />
      <LegislativnyMaterialDetailRow
        header="Zodpovedný predkladateľ"
        data={materialDetail?.zodpovednyPredkladatel == null && materialDetail?.typ?.kod !== 'AktEU'
          ? 'Používateľ nenájdený' : materialDetail?.zodpovednyPredkladatel?.nazov}
      />
      <LegislativnyMaterialDetailRow
        header="Ďalší predkladatelia"
        data={materialDetail?.dalsiPredkladatelia.map(dalsiPredkladatel => (dalsiPredkladatel.predkladatel == null
          ? { nazov: 'Používateľ nenájdený' } : dalsiPredkladatel.predkladatel))}
        itemAttributeToShow="nazov"
      />
      <LegislativnyMaterialDetailRow
        header="Skrátené PK"
        data={materialDetail.skrateneMpk ? 'Áno' : 'Nie'}
      />
      <LegislativnyMaterialDetailRow
        header="Dôvod skrátenia PK"
        data={materialDetail?.dovodSkratenehoMpk}
      />
      <LegislativnyMaterialDetailRow
        header="Posledná zmena"
        data={materialDetail.poslednaZmena ? mapDate(materialDetail.poslednaZmena) : null}
      />
      <LegislativnyMaterialDetailRow
        header={isPredbeznaInformacia() ? 'Dátum začiatku vyjadrení' : 'Dátum začiatku PK'}
        data={materialDetail.datumZaciatkuPkMpk ? mapDate(materialDetail.datumZaciatkuPkMpk) : null}
      />
      <LegislativnyMaterialDetailRow
        header={isPredbeznaInformacia() ? 'Dátum ukončenia vyjadrení' : 'Dátum ukončenia PK'}
        data={materialDetail.datumUkonceniaPkMpk ? mapDate(materialDetail.datumUkonceniaPkMpk) : null}
      />
      <LegislativnyMaterialDetailRow
        header="Dôvod zrušenia PK"
        data={materialDetail.dovodZruseniaMpk}
      />
      <LegislativnyMaterialDetailRow
        header="Výsledok rokovania NR SR"
        data={materialDetail.vysledokNrSr}
      />
      <NovelizovanyPredpis
        label="Hlavný novelizovaný predpis"
        data={materialDetail?.hlavnyNovelizovanyPredpis}
      />
      <NovelizovanyPredpis
        label="Ďalšie novelizované predpisy"
        data={materialDetail?.novelizovanePredpisy}
      />
      <SuvisiaciProcesList
        data={materialDetail?.suvisiaceProcesy}
      />
      <NovelizovanyPredpis
        label="Vyhlásený pod číslom"
        data={materialDetail?.vyhlasenyPodCislomList}
      />
    </>
  );
};

export default LegislativnyMaterialBasicData;
